import React from 'react';
import './AboutUs.css';
import { Link } from 'react-router-dom';

const AboutUs = () => {
  return (
    <section id="about" className="aboutus-section" style={{ backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/about-bg.jpg'})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }} >
      <div className="aboutus-container">
        <div className="aboutus-image">
          <img
            src={process.env.PUBLIC_URL + '/assets/about-icecream.png'}
            alt="Ice Cream"
          />
        </div>
        <div className="aboutus-content">
          <h2>
            About <span>Kwality</span>
          </h2>
          <h3>More Than Just Ice Cream</h3>
          <p>
            At Kwality, we don’t just make ice cream — we craft smiles, scoop by scoop. With
            decades of legacy and a heart full of flavor, Kwality brings you the perfect blend of
            creamy indulgence and unforgettable taste. From classic favorites to exciting new
            swirls, every bite is a celebration of quality, freshness, and joy.
          </p>
          <p>
            Whether it’s a sunny day or a cozy evening, Kwality is your go-to treat for every
            moment. Made with love, crafted with care — because you deserve nothing but the best.
          </p>
          <Link to="/novelties" className="aboutus-button">
            View Menu <span>&raquo;</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
